<div class="tile">
  <div class="header">
    <div class="title">{{ 'DASHBOARD.ORDERS.TITLE' | translate }}</div>
  </div>
  <div class="body">
    <div class="buttons">
      <div class="button" (click)="createOrderClicked()" *ngIf="showCreate">
        <div class="icon fa">
          <i class="fa fa-plus-square-o" aria-hidden="true"></i>
        </div>
        <div class="title">
          <div class="line1">{{ 'SHARED.VERBS.CREATE' | translate }}</div>
          &nbsp;
          <div class="line2">{{ 'SHARED.ITEM_TYPES.ORDER' | translate }}</div>
        </div>
      </div>

      <div class="button" (click)="viewOrdersClicked()">
        <div class="icon fa">
          <i class="fa fa-eye" aria-hidden="true"></i>
        </div>
        <div class="title">
          <div class="line1">{{ 'SHARED.VERBS.VIEW' | translate }}</div>
          &nbsp;
          <div class="line2">{{ 'DASHBOARD.ORDERS.ORDERS' | translate }}</div>
        </div>
      </div>
    </div>
  </div>
</div>
